import Link from 'next/link';

import styles from './FooterLink.module.css';

interface IFooterLink {
  text: string;
  link: string;
  id?: string;
}

export const FooterLink = ({ id, text, link }: IFooterLink) => {
  return (
    <Link href={link} id={id} className={styles.footerLink}>
      {text}
    </Link>
  );
};

export const FooterExternal = ({ id, text, link }: IFooterLink) => {
  return (
    <a
      id={id}
      rel="noopener noreferrer"
      target="_blank"
      href={link}
      className={styles.footerLink}
    >
      {text}
    </a>
  );
};
